var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',[_c('v-card-title',[_vm._v(" Knowledge base ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }